import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
	Button,
	Grid,
	Row,
	Col,
	Modal
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import { gql } from '@apollo/client';
// Component
import Avatar from '../../Avatar';
import CountryList from '../../CountryList';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from "react-bootstrap/lib/FormControl";
import InputGroup from 'react-bootstrap/lib/InputGroup';
import Loader from '../../Loader';
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';

// Helper
import showToaster from '../../../helpers/showToaster';

// Actions  
import { loadAccount } from '../../../actions/account';

// Locale
import messages from '../../../locale/messages';

import bt from '../../../components/commonStyle.css';
import s from './Meetup.css';

const ADD_PHONE_NUMBER = gql`
	mutation AddPhoneNumber($countryCode: String!, $phoneNumber: String!, $countryName: String, $userId: String) {
		AddPhoneNumber(countryCode: $countryCode, phoneNumber: $phoneNumber, countryName: $countryName, userId: $userId) {
			status
			phoneNumber
			countryCode
		}
	}
`;
class Meetup extends Component {
	static propTypes = {
		hostDisplayName: PropTypes.string.isRequired,
		hostPicture: PropTypes.string,
		guestDisplayName: PropTypes.string,
		guestPicture: PropTypes.string,
		nextPage: PropTypes.any.isRequired,
		emailVerified: PropTypes.bool.isRequired,
		phoneNumber: PropTypes.string,
		userId: PropTypes.string,
		dispatch: PropTypes.func,
		formatMessage: PropTypes.any,
	};

	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);
		this.state = {
			countryCode: 'TN',
			country: '+216',
			phoneNumber: '',
			submitting: false,
			showModal: false,
			phoneError: null
		};
	}

	handleClick() {
		const { phoneNumber, nextPage, emailVerified, guestPicture } = this.props;
		
		if (!phoneNumber) {
			// No phone number - open modal with phone form
			this.setState({ showModal: true });
		} else {
			// Has phone number - proceed directly to payment
			// if (guestPicture === null) {
			// 	nextPage('avatar');
			// } else if (!emailVerified) {
			// 	nextPage('verification');
			// } else {
				nextPage('payment');
			// }
		}
	}

	handleCloseModal = () => {
		this.setState({ showModal: false });
	}

	handleConfirmNext = () => {
		const { nextPage, emailVerified, guestPicture } = this.props;
		this.setState({ showModal: false });

		// Go directly to payment
		// if (guestPicture === null) {
		// 	nextPage('avatar');
		// } else if (!emailVerified) {
		// 	nextPage('verification');
		// } else {
			nextPage('payment');
		// }
	}

	handlePhoneChange = (event) => {
		const value = event.target.value;
		this.setState({ 
			[event.target.name]: value,
			phoneError: null // Clear error on change
		});
		
		// Real-time validation
		if (value) {
			this.validatePhoneNumber(value);
		}
	}

	validatePhoneNumber = (phoneNumber) => {
		const { countryCode } = this.state;
		
		try {
			// Clean the number (remove spaces, dashes, etc.)
			const cleanNumber = phoneNumber.replace(/[\s\-\(\)\.]/g, '');
			
			// Basic checks first
			if (!cleanNumber) {
				this.setState({ phoneError: 'required' });
				return false;
			}
			
			if (!/^\d+$/.test(cleanNumber)) {
				this.setState({ phoneError: 'digitsOnly' });
				return false;
			}
			
			// Use libphonenumber-js for validation
			const isValid = isValidPhoneNumber(cleanNumber, countryCode);
			
			if (!isValid) {
				this.setState({ phoneError: 'invalidNumber' });
				return false;
			}
			
			this.setState({ phoneError: null });
			return true;
			
		} catch (error) {
			this.setState({ phoneError: 'invalidNumber' });
			return false;
		}
	}

	handleCountryChange = (e, selectedData) => {
		this.setState({
			country: selectedData.dialCode,
			countryCode: selectedData.countryCode,
			phoneError: null // Clear error on country change
		});
		
		// Re-validate if there's a phone number
		const { phoneNumber } = this.state;
		if (phoneNumber) {
			// Use setTimeout to ensure state is updated first
			setTimeout(() => {
				this.validatePhoneNumber(phoneNumber);
			}, 0);
		}
	}

	savePhoneNumber = async () => {
		const { country, phoneNumber, countryCode } = this.state;
		const { userId, dispatch, loadAccount } = this.props;

		// Validate phone number before saving
		const isValid = this.validatePhoneNumber(phoneNumber);
		if (!isValid) {
			return;
		}

		this.setState({ submitting: true });

		// Create inline action instead of separate file for simplicity
		const addPhoneNumberAction = (countryCode, phoneNumber, countryName, userId) => {
			return async (dispatch, getState, { client }) => {
				try {
					const { data } = await client.mutate({
						mutation: ADD_PHONE_NUMBER,
						variables: {
							countryCode,
							phoneNumber,
							countryName,
							userId
						}
					});
					return data;
				} catch (error) {
					throw error;
				}
			};
		};

		try {
			const data = await dispatch(addPhoneNumberAction(country, phoneNumber, countryCode, userId));
			
			if (data.AddPhoneNumber.status === '200') {
				// Phone number saved successfully - reload account data and proceed
				await loadAccount();
				this.setState({ showModal: false });
				this.handleConfirmNext();
			} else {
				// Handle error
				this.setState({ submitting: false });
			}
		} catch (error) {
			console.error('Error saving phone number:', error);
			this.setState({ submitting: false });
			showToaster({ messageId: 'commonError', toasterType: 'error' });
		}
	}

	getErrorMessage = (errorType) => {
		const { formatMessage } = this.props.intl;
		
		const errorMessages = {
			required: formatMessage(messages.phoneRequired),
			digitsOnly: formatMessage(messages.phoneDigitsOnly),
			invalidNumber: formatMessage(messages.phoneInvalidNumber),
		};
		
		return errorMessages[errorType] || formatMessage(messages.phoneInvalidNumber);
	}

	render() {
		const { hostDisplayName, hostPicture, guestDisplayName, phoneNumber, userId, isHostPhotoMigrated, isGuestPhotoMigrated } = this.props;
		const { country, phoneNumber: statePhoneNumber, submitting, countryCode, showModal, phoneError } = this.state;
		const { formatMessage } = this.props.intl;

		return (
			<div>
				<Grid fluid className={s.container}>
					<Row>
						<Col xs={12} sm={12} md={12} lg={12}>
							<h2 className={cx(s.titleText, s.space5)}>
								<FormattedMessage {...messages.meetupTitle} /> {hostDisplayName}
							</h2>
							<div>
								<div className={s.userAvatarSection}>
									<Avatar
										source={hostPicture}
										title={hostDisplayName}
										className={cx(s.profileImage, s.mediaPhoto, s.mediaRound)}
										isFromMigration={isHostPhotoMigrated}
									/>
								</div>
								<div className={cx(s.userAvatarSection, s.rightAvatar, 'rightAvatarRTL')}>
									<Avatar
										isUser
										title={guestDisplayName}
										className={cx(s.profileImage, s.mediaPhoto, s.mediaRound)}
										isFromMigration={isGuestPhotoMigrated}
									/>
								</div>
								<p className={cx(s.space2, s.spaceTop2, s.textLead)}>
									<FormattedMessage {...messages.meetupInfo1} />
								</p>
								<p className={cx(s.space3, s.textLead)}>
									<FormattedMessage {...messages.meetupInfo2} />
								</p>

								<Button className={cx(bt.btnPrimary, bt.btnLarge, s.btnWidth)} onClick={this.handleClick}>
									<FormattedMessage {...messages.next} />
								</Button>
							</div>
						</Col>
					</Row>
				</Grid>

				{/* Modal */}
				<Modal 
					show={showModal} 
					onHide={this.handleCloseModal}
					animation={false}
					dialogClassName={'loginModal'}
				>
					<Modal.Header closeButton>
						<Modal.Title>
							<FormattedMessage {...messages.addAPhoneNumber} />
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className={s.root}>
							<div className={s.modalContent}>
								<p>
									<FormattedMessage 
										{...messages.meetupPhonePrompt} 
										values={{ hostDisplayName: <strong>{hostDisplayName}</strong> }} 
									/>
								</p>
								<div className={s.noticeText}>
									<FormattedMessage {...messages.phoneNumberInfo} />
								</div>
							</div>
							
							<div className={s.formSection}>
								
								<FormGroup className={s.formGroup}>
									<label className={cx(s.labelText)}>
										<FormattedMessage {...messages.chooseACountry} />
									</label>
									<CountryList
										input={{
											name: 'countryCode',
											onChange: this.handlePhoneChange,
											value: countryCode
										}}
										className={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
										dialCode={false}
										getSelected={this.handleCountryChange}
									/>
								</FormGroup>

								<FormGroup className={s.formGroup}>
									<label className={cx(s.labelText)}>
										<FormattedMessage {...messages.addAPhoneNumber} />
									</label>
									<InputGroup>
										<InputGroup.Addon>{country}</InputGroup.Addon>
										<FormControl
											name="phoneNumber"
											value={statePhoneNumber}
											placeholder=""
											type="text"
											className={cx(bt.commonControlInput, phoneError && s.errorInput)}
											onChange={this.handlePhoneChange}
										/>
									</InputGroup>
									{phoneError && (
										<span className={s.errorMessage}>
											{this.getErrorMessage(phoneError)}
										</span>
									)}
								</FormGroup>
							</div>
							
							<div className={cx(bt.btnFlexContainerEnd, bt.gap16, bt.space3)}>
								<Button
									onClick={this.handleCloseModal} 
									className={cx(bt.btnPrimaryBorder)}
								>
									<FormattedMessage {...messages.cancel} />
								</Button>
								<Loader
									type={"button"}
									buttonType={"button"}
									show={submitting}
									disabled={submitting || !statePhoneNumber || phoneError}
									label={formatMessage(messages.saveContinue)}
									handleClick={this.savePhoneNumber}
									className={cx(bt.btnPrimary, 'commonLoaderFlex')}
								/>
							</div>
						</div>
					</Modal.Body>
				</Modal>
			</div>
		);
	}
}

const mapState = (state) => ({
	// Map any state you need
});

const mapDispatch = (dispatch) => ({
	dispatch,
	loadAccount: () => dispatch(loadAccount())
});

export default connect(mapState, mapDispatch)(injectIntl(withStyles(s, bt)(Meetup)));